import { useTranslation } from 'react-i18next';
import styles from '../Modal.module.scss';

type Props = {
  productId: number;
  descriptionContent: JSX.Element | string;
};

const LitigationContent = ({ productId, descriptionContent }: Props) => {
  const { t } = useTranslation();

  return (
    <div className={styles.containerGap}>
      <div className={styles.text1rem}>{`${t('common.item')} #${productId}`}</div>
      <div className={styles.text1rem}>{descriptionContent}</div>
    </div>
  );
};

export default LitigationContent;
